import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push, replace } from 'connected-react-router'

import MainView from '../components/MainView/MainView'

import { setStep } from '../../../modules/registration/actions/creators'

import {
  setHeroBanner,
  setHeroBanners,
  setMalls,
  setCMSMalls,
  setStoreModalData,
  setCardListModalData,
  setCardListModalStatus,
} from '../../../modules/dashboard/actions/creators'

import {
  setMerchantOrder,
  setMerchantShop,
  setMerchantDine,
  setMerchantUnwind,
  setMerchantPopular,
  setMerchantModalData,
  setMerchantModalStatus,
  setDisplayMallWelcome,
  setSelectedMallSlug,
} from '../../../modules/explore/actions/creators'

import {
  setPrimaryInfo,
  setFavoriteMalls,
  displayProfileModal,
  setNotificationCount,
  setProfileModalPage,
  setTransportationMall,
  setAccountStatus,
  setPreferenceIds,
} from '../../../modules/profile/actions/creators'

import {
  setAccessToken,
  setFirebaseMessagingToken,
} from '../../../modules/auth/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import {
  setLoyaltyPoints,
  setTransactionsEarned,
  setTransactionsRedeemed,
} from '../../../modules/loyalty/actions/creators'

import { setError, removeError } from '../../../modules/errors/actions/creators'

import { withFirebase } from '../../../components/accessibility/Firebase/Firebase'

import {
  doSubscribeToFirebaseMessaging,
  doSubscribeToFirebaseGuest,
} from '../../../controllers/Firebase'

import { doGetFeaturedMarketingContent } from '../../../controllers/MarketingContent'

const mapStateToProps = reduxState => {
  const {
    dashboard,
    registration,
    auth,
    profile,
    explore,
    loyalty,
    errors,
  } = reduxState
  const { accessToken, firebaseMessagingToken } = auth
  const { step } = registration
  const {
    primaryInfo,
    registrationToken,
    favoriteMalls,
    advanceAccount,
    preferenceIds,
  } = profile
  const {
    heroBanner,
    heroBanners,
    malls,
    cmsMalls,
    showStoreModal,
    storeModalData,
    cardListModalData,
    showCardListModal,
    cardListModalStatus,
  } = dashboard
  const {
    orderShop,
    shop,
    dine,
    unwind,
    popular,
    showMerchantModal,
    merchantModalData,
    merchantModalStatus,
    displayMallWelcome,
    selectedMallSlug,
  } = explore
  const { loyaltyPoints, transactionsEarned, transactionsRedeemed } = loyalty
  const { errorList } = errors
  const { deviceLocation } = dashboard

  return {
    heroBanner,
    heroBanners,
    primaryInfo,
    preferenceIds,
    registrationToken,
    accessToken,
    orderShop,
    shop,
    dine,
    unwind,
    popular,
    malls,
    cmsMalls,
    selectedMallSlug,
    showMerchantModal,
    merchantModalData,
    cardListModalData,
    showCardListModal,
    cardListModalStatus,
    merchantModalStatus,
    displayMallWelcome,
    loyaltyPoints,
    transactionsEarned,
    transactionsRedeemed,
    showStoreModal,
    storeModalData,
    favoriteMalls,
    deviceLocation,
    showAddFavorite: step > 1,
    errorList,
    firebaseMessagingToken,
    doSubscribeToFirebaseGuest,
    doSubscribeToFirebaseMessaging,
    advanceAccount,
    doGetFeaturedMarketingContent,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setLoyaltyPoints,
      setTransactionsEarned,
      setTransactionsRedeemed,
      setHeroBanner,
      setHeroBanners,
      setPrimaryInfo,
      displayProfileModal,
      setTransportationMall,
      setProfileModalPage,
      setNotificationCount,
      setAccessToken,
      setMerchantOrder,
      setMerchantShop,
      setMerchantDine,
      setMerchantUnwind,
      setMerchantPopular,
      setMerchantModalData,
      setMerchantModalStatus,
      setDisplayMallWelcome,
      setMalls,
      setCMSMalls,
      setSelectedMallSlug,
      setCardListModalData,
      setCardListModalStatus,
      push,
      replace,
      waitRenderServer,
      renderServer,
      setStoreModalData,
      setFavoriteMalls,
      disableFavoritePrompt: () => setStep(1),
      setError,
      removeError,
      setFirebaseMessagingToken,
      setAccountStatus,
      setPreferenceIds,
    },
    dispatch,
  )

const ConnectedMainView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withFirebase(MainView))

export default ConnectedMainView
